export default __webpack_public_path__ + "static/media/images.c7da87b7.jpeg";